import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendEmailVerification, signOut } from "firebase/auth";
import { auth } from "../config/firebase";

export default function VerifyEmail({ user }) {
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);

  const resend = async () => {
    setBusy(true); setStatus("");
    try {
      await sendEmailVerification(auth.currentUser);
      setStatus("sent");
    } catch {
      setStatus("error");
    }
    setBusy(false);
  };

  const recheck = async () => {
    setBusy(true); setStatus("");
    try {
      await auth.currentUser?.reload();
      if (auth.currentUser?.emailVerified) {
        window.location.reload();
        return;
      }
      setStatus("pending");
    } catch {
      setStatus("error");
    }
    setBusy(false);
  };

  const handleSignOut = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <div style={{
      minHeight: "100vh", background: "var(--bg, #000)",
      display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
    }}>
      <div style={{ width: "100%", maxWidth: 340 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 36 }}>
          <div style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--green, #22c55e)" }} />
          <span style={{ fontFamily: "var(--mono, monospace)", fontSize: 13, color: "var(--text, #fff)" }}>greenline</span>
        </div>

        <div className="label" style={{ marginBottom: 8 }}>VERIFY_EMAIL</div>
        <div style={{ fontSize: 15, fontWeight: 500, color: "var(--text, #fff)", marginBottom: 6 }}>
          Confirm your email
        </div>
        <div className="mono" style={{ fontSize: 11, color: "var(--text-muted, #888)", lineHeight: 1.7, marginBottom: 20 }}>
          we sent a verification link to <span style={{ color: "var(--green, #22c55e)" }}>{user?.email}</span>.
          click it, then come back and continue.
        </div>

        {status === "sent" && (
          <div className="badge badge-green" style={{ display: "block", marginBottom: 12 }}>verification email sent</div>
        )}
        {status === "pending" && (
          <div className="badge badge-amber" style={{ display: "block", marginBottom: 12 }}>not verified yet — check your inbox/spam</div>
        )}
        {status === "error" && (
          <div className="badge badge-red" style={{ display: "block", marginBottom: 12 }}>couldn't send — try again in a minute</div>
        )}

        <button className="btn btn-green" onClick={recheck} disabled={busy} style={{ width: "100%", fontSize: 12, marginBottom: 8 }}>
          {busy ? "checking…" : "i've verified — continue →"}
        </button>
        <button className="btn" onClick={resend} disabled={busy} style={{ width: "100%", fontSize: 11, marginBottom: 16 }}>
          resend email
        </button>

        <div style={{ textAlign: "center" }}>
          <button
            onClick={handleSignOut}
            style={{ background: "none", border: "none", fontFamily: "var(--mono, monospace)", fontSize: 10, color: "var(--text-dim, #555)", cursor: "pointer" }}
          >
            sign out
          </button>
        </div>
      </div>
    </div>
  );
}
